import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { EUserType } from "../enums/EUserType";
import { IUser } from "../interfaces/IUser";

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    allPaths = {
        root: {
            '/root-user': true,
        },
        admin: {
            '/admin-dashboard': true,
            '/users': true,
            '/cities': true,
            '/courier': true,
            '/banks': true,
            '/taxes': true,
            '/payment-mode': true,
            '/payment-type': true,
            '/product-group': true,
            '/products': true,
            '/payment-receipts': true,
            '/orders': true,
        },
    }

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    // @ts-ignore
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let user: IUser = this.authService.gUser;
        if (user && user._id) {
            if (user.usr_type_str === EUserType.ROOT) {
                // @ts-ignore
                if (this.allPaths.root[state.url]) return true;
                else {
                    this.router.navigate(['root-dashboard']).then();
                    return false;
                }
            } else if (user.usr_type_str === EUserType.ADMIN) {
                // @ts-ignore
                if (this.allPaths.admin[state.url]) return true;
                else {
                    this.router.navigate(['admin-dashboard']).then();
                    return false;
                }
            }
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}
